// @utility
import { setStorage, removeStorage } from "@utility/app/storage";
import alertText from "@utility/app/alertText";

// Services
import { apiServices } from "@core/services/appService";

// Redux
import { setStatusSpinner } from "@core/redux/actions/app/spinner";
import { setSnackbarData } from "@core/redux/actions/app/snackbar";
import { loadHomeData } from "@core/redux/actions/home/index";
import { setDataAlert } from "@core/redux/actions/app/alert";
import { loadTableData } from "@core/redux/actions/history";

const LOAD_DATA_WITHDRAW = "app/withdraw/SET_WITHDRAW_DATA";
const SET_WITHDRAW_RANK_DATA = "app/withdraw/SET_WITHDRAW_RANK_DATA";

function setWithdrawData(data) {
  return {
    type: LOAD_DATA_WITHDRAW,
    payload: {
      items: data,
    },
  };
}

function loadDataWithdraw() {
  return (dispatch) => {
    apiServices(
      {},
      "get",
      "/customer/payment-v2/withdraw/channel-lottery",
    ).then((data) => {
      const { code: statusCode, result } = data;
      dispatch(setStatusSpinner({ status: false, textProcess: null }));

      if (statusCode === 200 || statusCode === 0) {
        dispatch({
          type: LOAD_DATA_WITHDRAW,
          payload: {
            items: result,
          },
        });
      } else {
        dispatch({
          type: LOAD_DATA_WITHDRAW,
          payload: {
            items: null,
          },
        });
      }
    });
  };
}

function setWithdrawRankData() {
  return (dispatch) => {
    apiServices({}, "get", "/common/section/withdraw").then((data) => {
      const { code: statusCode, result } = data;

      if (statusCode === 200 || statusCode === 0) {
        dispatch({
          type: SET_WITHDRAW_RANK_DATA,
          payload: {
            items: result,
          },
        });
      } else {
        dispatch({
          type: SET_WITHDRAW_RANK_DATA,
          payload: {
            items: null,
          },
        });
      }
    });
  };
}

function confirmWithdraw(
  data,
  path = "",
) {
  return (dispatch) => {
    const { amount, bankId, channel, channelId } = data;

    let dataJson = {
      amount: amount,
      bankId: bankId,
      select: 0,
      channel,
      channelId,
    };

    dispatch(setStatusSpinner({ status: true, textProcess: null }));
    // return promise ให้ฟอร์มรู้ว่า request จบเมื่อไหร่ (ใช้ปลดล็อกปุ่มถอน)
    return apiServices(dataJson, "post", path).then((data) => {
      const { code: statusCode, result } = data;
      dispatch(setStatusSpinner({ status: false, textProcess: null }));

      if (statusCode === 200 || statusCode === 0) {
        dispatch(loadHomeData());
        dispatch(setWithdrawData(result));
        setStorage("processWithdraw", 1);
        dispatch(loadTableData("payment-v2", 10, 0, "", "", "withdraw"));
      } else {
        let snackbarJson = alertText(statusCode);
        dispatch(
          setDataAlert({
            type: snackbarJson.statusAlert,
            title: snackbarJson.titleAlert,
            text: snackbarJson.textAlert,
            action: true,
            redirect: null,
            show: true,
            buttonText: "ตกลง",
          }),
        );
      }
    });
  };
}

function checkWithdraw(checkTime, withdrawId, typePage) {
  return (dispatch) => {
    apiServices(
      { id: withdrawId },
      "post",
      "/customer/payment/withdraw/check",
    ).then((data) => {
      const { code: statusCode } = data;

      if (statusCode === 200 || statusCode === 0) {
        switch (data.result.status) {
          case 0:
          case 1:
          case 2:
          case 21:
          case 31:
            break;
          case 3:
            if (typePage === "withdraw") {
              dispatch(
                setDataAlert({
                  type: "success",
                  title: "แจ้งเตือน",
                  text: "ทำรายการถอนเงินสำเร็จ !",
                  action: true,
                  redirect: null,
                  show: true,
                  buttonText: "ตกลง",
                }),
              );
            } else {
              dispatch(
                setSnackbarData({
                  statusShow: true,
                  statusAlert: "success",
                  titleAlert: "แจ้งเตือน",
                  textAlert: "ทำรายการถอนเงินสำเร็จ !",
                }),
              );
            }

            dispatch(loadDataWithdraw());
            dispatch(loadHomeData());

            if (checkTime) {
              clearInterval(checkTime);
            }

            removeStorage("processWithdraw");
            break;
          case 4:
            dispatch(
              setDataAlert({
                type: "warning",
                title: "แจ้งเตือน",
                text: "ยกเลิกรายการถอนเงิน เนื่องจากมีเงื่อนไขบางอย่างไม่ถูกต้อง กรุณาติดต่อแอดมิน !",
                action: true,
                redirect: null,
                show: true,
                buttonText: "ตกลง",
              }),
            );

            dispatch(loadHomeData());
            dispatch(loadDataWithdraw());

            if (checkTime) {
              clearInterval(checkTime);
            }

            removeStorage("processWithdraw");
            break;
          default:
            dispatch(
              setDataAlert({
                type: "error",
                title: "แจ้งเตือน",
                text: "ทำรายการถอนเงินไม่สำเร็จ! กรุณาติดต่อแอดมิน",
                action: true,
                redirect: null,
                show: true,
                buttonText: "ตกลง",
              }),
            );

            if (checkTime) {
              clearInterval(checkTime);
            }

            removeStorage("processWithdraw");
            break;
        }
      } else {
        let snackbarJson = alertText(statusCode);
        dispatch(setSnackbarData(snackbarJson));
      }
    });
  };
}

function confirmWithdrawCrypto(
  data,
  path = "/customer/payment-v3/withdraw/submit-crypto",
) {
  return (dispatch) => {
    const { amount, bankId, channelId } = data;

    const formData = new FormData();
    formData.append("amount", amount);
    formData.append("bankId", bankId);
    formData.append("channelId", channelId);

    // console.log("=== confirmWithdrawCrypto Request (FormData) ===");
    // console.log("URL:", path);
    for (let pair of formData.entries()) {
      console.log(pair[0] + ': ' + pair[1]);
    }

    dispatch(setStatusSpinner({ status: true, textProcess: null }));
    apiServices(formData, "file", path).then((res) => {
      console.log("=== confirmWithdrawCrypto Response ===");
      console.log(res);

      const { code: statusCode, message } = res;
      dispatch(setStatusSpinner({ status: false, textProcess: null }));

      if (statusCode === 200 || statusCode === 0) {
        dispatch(
          setDataAlert({
            type: "success",
            title: "แจ้งเตือน",
            text: "ทำรายการถอนเงินคริปโตสำเร็จ !",
            action: true,
            redirect: null,
            show: true,
            buttonText: "ตกลง",
          }),
        );

        dispatch(loadHomeData());
        dispatch(loadDataWithdraw());
        removeStorage("processWithdraw");
      } else {
        let snackbarJson = alertText(message || statusCode);
        dispatch(
          setDataAlert({
            type: snackbarJson.statusAlert || "warning",
            title: snackbarJson.titleAlert || "แจ้งเตือน",
            text: snackbarJson.textAlert || message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
            action: true,
            redirect: null,
            show: true,
            buttonText: "ตกลง",
          }),
        );
      }
    });
  };
}

function confirmWithdrawP2P(
  data,
  path = "",
) {
  return (dispatch) => {
    const { amount, bankId, channel, channelId } = data;

    let dataJson = {
      amount: amount,
      bankId: bankId,
      select: 0,
      channel,
      channelId,
    };

    dispatch(setStatusSpinner({ status: true, textProcess: null }));
    apiServices(dataJson, "post", path).then((data) => {
      const { code: statusCode, result } = data;
      dispatch(setStatusSpinner({ status: false, textProcess: null }));

      if (statusCode === 200 || statusCode === 0) {
        dispatch(loadDataWithdraw());
        dispatch(loadHomeData());
        dispatch(setWithdrawData(result));
        setStorage("processWithdraw", 1);
        dispatch(loadTableData("payment-v2", 10, 0, "", "", "withdraw"));
      }
      else if (statusCode === 79) {
        dispatch(setDataAlert({
          type: "warning",
          title: "แจ้งเตือน",
          text: `สร้างรายการไม่สำเร็จ เนื่องจากไม่สามารถเชื่อมต่อกับผู้ให้บริการได้ <div class="alertMessageError">** หมายเหตุ : ${result?.message} **</div>`,
          action: true,
          redirect: null,
          show: true,
          buttonText: "ตกลง"
        }));
      }
      else {
        let snackbarJson = alertText(statusCode);
        dispatch(
          setDataAlert({
            type: snackbarJson.statusAlert,
            title: snackbarJson.titleAlert,
            text: snackbarJson.textAlert,
            action: true,
            redirect: null,
            show: true,
            buttonText: "ตกลง",
          }),
        );
      }
    });
  };
}

function cancelWithdraw(id, gotoPageForce, noProcess, onCancel) {
  return dispatch => {
    dispatch(setStatusSpinner({ status: true, textProcess: null }));

    // 📍 ส่ง id เข้าไปใน Payload ให้ฝั่ง Go รับค่าได้
    apiServices({ id: parseInt(id) }, "POST", "/customer/payment-v3/withdraw/cancel-p2p").then((data) => {
      const { code: statusCode, message } = data;

      dispatch(setStatusSpinner({ status: false, textProcess: null }));

      if (statusCode === 200 || statusCode === 0) {
        dispatch(loadDataWithdraw());
        removeStorage("withdrawResult");

        if (!noProcess) {
          dispatch(setDataAlert({
            type: "success",
            title: "แจ้งเตือน",
            text: "ยกเลิกสำเร็จ !",
            action: true,
            redirect: null,
            show: true,
            buttonText: "ตกลง"
          }));
        }

        if (typeof gotoPageForce === "function") {
          // gotoPageForce("/withdraw");
          gotoPageForce("home");
        }

        if (onCancel) {
          onCancel();
        }
      }
      else if (statusCode !== 39 && statusCode !== 0) {
        let snackbarJson = alertText(statusCode);
        dispatch(setDataAlert({
          type: snackbarJson.statusAlert,
          title: snackbarJson.titleAlert,
          text: statusCode === 99 ? (message ? message : snackbarJson.textAlert) : snackbarJson.textAlert,
          action: true,
          redirect: null,
          show: true,
          buttonText: "ตกลง"
        }));
      }
    }).catch((error) => {
      dispatch(setStatusSpinner({ status: false, textProcess: null }));
      console.error("Cancel Withdraw Error:", error);
    });
  }
}

export {
  LOAD_DATA_WITHDRAW,
  SET_WITHDRAW_RANK_DATA,
  setWithdrawData,
  loadDataWithdraw,
  confirmWithdraw,
  confirmWithdrawCrypto,
  checkWithdraw,
  setWithdrawRankData,
  confirmWithdrawP2P,
  cancelWithdraw
};
